<footer>
    <div class="container-fluid bg-wrapper">
        <div class="container">
            <div class="row">
                <!--Contact-->
                <div class="col-12">
                    <div class="footer-contact-container">
                        <form (ngSubmit)="subMailChimp(subForm)" #subForm='ngForm' *ngIf="!submitted">
                            <div class="row">
                                <div class="col-md-9 col-12">
                                    <div class="form-group mb-2">
                                        <label for="subEmail" class="sr-only">Email</label>
                                        <input type="email" class="form-control" id="subEmail" placeholder="Email"
                                               ngModel name="email">
                                    </div>
                                </div>
                                <div class="col-md-3 col-12">
                                    <button type="submit" class="btn btn-primary w-100">{{'FOOTER.BUTTON' | translate}}</button>
                                </div>
                            </div>
                        </form>
                        <div class="row" *ngIf="submitted">
                            <div class="col-12">
                                <div class="text-center text-white font-weight-bold">
                                    Te-ai abonat cu succes!
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--Social Media & Logo-->
            <div class="row">
                <div class="col-sm-6 col-lg-3 col-12">
                    <div class="footer-item">
                        <div class="footer-logo text-sm-left text-center mb-sm-0 mb-20">
                            <a routerLink="/"><img src="/assets/img/header-footer/logo-footer.png" alt="Logo"></a>
                            <p class="text-white" [innerHTML]="'FOOTER.TEXT_HTML' | translate"></p>
                            <ul>
                                <li><a href="#" target="_blank"><i class="icofont-facebook text-white"></i></a></li>
                                <li><a href="#" target="_blank"><i class="icofont-linkedin text-white"></i></a></li>
                                <li><a href="#" target="_blank"><i class="icofont-instagram text-white"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!--General-->
                <div class="col-sm-6 col-lg-3 col-12">
                    <div class="footer-item">
                        <div class="footer-category text-sm-left text-center mb-sm-0 mb-20">
                            <h3 class="m-0">General</h3>
                            <ul>
                                <li><a routerLink="/intrebari-frecvente">{{'FOOTER.QUESTIONS' | translate}}</a></li>
                                <li><a routerLink="/blog">Blog</a></li>
                                <li><a routerLink="/consiliere-si-orientare-cariera">{{'FOOTER.OREINTATION' | translate}}</a>
                                <li><a routerLink="/contact">Contact</a></li>
                                <li><a routerLink="/termeni-si-conditii">{{'FOOTER.TERMS' | translate}}</a></li>
                                <li><a routerLink="/politica-confidentialitate">{{'FOOTER.POLICY' | translate}}</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!--Companies-->
                <div class="col-sm-6 col-lg-3 col-12">
                    <div class="footer-item">
                        <div class="footer-category text-sm-left text-center mb-sm-0 mb-20">
                            <h3 class="m-0">{{'LOGIN.COMPANY' | translate}}</h3>
                            <ul>

                                <li *ngIf="!isLoggedIn"><a routerLink="/inregistrare">Doresc cont angajator</a></li>
                                <li *ngIf="haveCompany"><a routerLink="/adauga-job">{{'ACCOUNT.ADD_JOB' | translate}}</a></li>
                                <li><a routerLink="/pachete">{{'NAVBAR.OFFER' | translate}}</a></li>
                                <li><a routerLink="/agentie-de-recrutare">{{'FOOTER.RECRUITING' | translate}}</a></li>
                                <li><a routerLink="/servicii-agri-jobs">{{'NAVBAR.SERVICES' | translate}}</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!--Candidates-->
                <div class="col-sm-6 col-lg-3 col-12">
                    <div class="footer-item">
                        <div class="footer-category text-sm-left text-center">
                            <h3 class="m-0">{{'LOGIN.CANDIDATE' | translate}}</h3>
                            <ul>
                                <li *ngIf="!isLoggedIn"><a routerLink="/inregistrare-candidat">{{'FOOTER.ACCOUNT' | translate}}</a></li>
                                <li><a routerLink="/joburi">{{'FOOTER.WORK' | translate}}</a></li>
                                <li><a routerLink="/comparator-salarii">{{'FOOTER.SELARY' | translate}}</a></li>
                                <li><a href="https://testeabj.nexloc.com/" target="_blank">{{'FOOTER.TEST' | translate}}</a></li>
                                <li><a routerLink="/evaluare-personalitate">{{'FOOTER.EVALUATE' | translate}}</a></li>
                                <li><a href="https://testeabj.nexloc.com/" target="_blank">E-learning</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <!--Copyright-->
            <div class="copyright-area">
                <div class="row">
                    <div class="col-12">
                        <div class="copyright-item">
                            <p class="text-white">Copyright @ {{'FOOTER.RIGHTS' | translate}}
                                <span class="copyright-link" > Agribusinessjob SRL</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
